export enum InterestType {
    Artist = 'artist',
    Category = 'tdl-category',
    Consent = 'consent',
    General = 'general',
    MainCategory = 'tdl-main-category',
    NoContact = 'no-contact',
    Venue = 'venue',
}
